import React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Table } from "../../components/CustomPaginations";
import overlayFactory from "react-bootstrap-table2-overlay";
import { tableStyle } from "../../components/TableStyle";

export const DevOpsTasksModal = ({
	showModal,
	handleClose,
	devOpsDate,
	devOpsEndDate,
	devOpsTasksData,
	taskName,
}) => {
	const getColumns = [
		{
			dataField: "workItemId",
			text: "Task ID",
			sort: true,
		},
		{
			dataField: "workItemTitle",
			text: "Title",
			sort: true,
		},
		{
			dataField: "workItemState",
			text: "State",
			sort: true,
			formatter: (cell, row) => {
				return (
					<span>
						{row.workItemState === "Active" ? (
							<span style={{ color: "#007acc" }}>
								{row.workItemState}
							</span>
						) : row.workItemState === "Closed" ? (
							<span style={{ color: "#339933" }}>
								{row.workItemState}
							</span>
						) : (
							<span>{row.workItemState}</span>
						)}
					</span>
				);
			},
		},
		{
			dataField: "hoursSpent",
			text: "Hours Logged",
			sort: true,
		},
	];
	return (
		<Modal
			show={showModal}
			onHide={handleClose}
			aria-labelledby="contained-modal-title-vcenter"
			centered
			size="xl"
			dialogClassName="modal-50w"
			className="addComments"
		>
			<Modal.Header closeButton className="pb-0 pr-4 pt-1 border-0" />
			<Modal.Body>
				<div
					className="pr-3"
					style={{ maxHeight: "550px", overflowY: "auto" }}
				>
					<div className="row text-center">
						<div className="col-lg-8 col-md-8 col-sm-12 font-weight-light mb-2 text-left">
							Project Name
							<div className="d-inline font-weight-bold han ml-2 projectName px-2 py-1">
								{taskName}
							</div>
						</div>

						<div className="col-lg-4 col-md-4 col-sm-6 d-flex date">
							<label className="font-weight-light">Date:</label>
							<span className="ml-3">
								{moment(devOpsDate).format("ddd DD MMM")}
								{devOpsEndDate &&
									" - " +
										moment(devOpsEndDate).format(
											"ddd DD MMM"
										)}
							</span>
						</div>
					</div>
					<div className="devOpsTable">
						<Table
							inputValue={""}
							keyField={"workItemId"}
							columns={getColumns}
							items={devOpsTasksData}
							tableStyle={tableStyle}
							defaultSorted={{
								dataField: "requestDate",
								order: "desc",
							}}
							showFeedback={false}
							tableLoader={false}
							SearchBar={() => {
								return null;
							}}
							loading={false}
							overlay={overlayFactory({
								spinner: true,
								styles: {
									overlay: (base) => ({
										...base,
										background: "rgba(255, 0, 0, 0.5)",
									}),
								},
							})}
						/>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};
export default DevOpsTasksModal;
